module.exports = __webpack_public_path__ + "static/img/resolvent6.03c5f1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/resolvent6.png
// module id = V09T
// module chunks = 13